<template>
  <div>
    <Row type="flex" align="middle">
      <i-col span="24" class="pa-5">
      <divider />
      <ul ul style="list-style-type:decimal-leading-zero;" class="p-30">
        <li>特码逢双为特双，特码逢单为特单，49号为和局。</li>
        <li>特码(01〜24)为小，特码(25~48)为大，49号为和局。</li>
        <li>两面（指大、小、单、双)。</li>
        <li>六合彩开奖七粒总和(包括特码)。</li>
        <li>特别号码：香港六合彩公司当期开出的最后一码为特码。</li>
        <li>特码大小：开出之特码大于或等于25为特码大，小于或等于24为特码小，49为和；特码单双：特码为双数叫特双，如2、 18 ;特码为单数叫特单，如17、33 ; 49为和。</li>
        <li>正码：六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码1，依次叫正码2、正码3……正码6，不以大小排序。</li>
        <li>总分大小：所有七个开奖号码的分数总和大于或等于175为总分大；分数總和小于或等于174为总分小。如开奨号码为01、07、15、29、38、46、24，分数總和是160，为总分小。</li>
        <li>总分单双：所有七个开奖号码的分数总和是单数叫总分单(总单），如分数總和是103、193 ;分数总和是双数叫总分双(总双） ，如分数總和是108、160。</li>
        <li>正码1-6特：正1特、正2特、正3特、正4特、正5特、正6特，指下注的正码特与现场滚波开出之正码其开奖顺序及开奖号码相同，视为中奖，例如：现场开奖第三个正码为29号，下注第三个正码特为29则视为中奖，其它号码视为不中奖，其他正特项目依此类推</li>
        <li>正码1、正码2、正码3、正码4、正码5、正码6的大小单双和特别号码的大小单双规则相同，如正码1为25，则正码1为大，为单；正码2为4，则正码2为小，为双；号码49，则为和。</li>
        <li>特码合数单双：指开出的特码的个位数加上十位数之和为奇数称合数单、之和为偶数称合数双，其中号码49为和。例如：合数单，01为0+1=1，23为2+3=5 ;合数双，28为2+8=10，39为3+9=12 ; 49为和。</li>
        <li>特码尾大尾小：指开出的特码的末尾数（即个位数〉大于或等于5为尾大，如15、39，小于或等于4为尾小，如11、33 ，其中号码49为和</li>
        <li>
          波色：指开出特码所属的颜色。
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >波色</th>
            </thead>
            <tbody>
            <tr class="bold">
              <th class="pc1">红色</th>
              <td class="pc1">01，02，07，08，12，13，18，19，23，24，29，30，34，35，40，45，46</td>
            </tr>
            <tr class="bold">
              <th class="pc2">蓝色</th>
              <td class="pc2">03，04，09，10，14，15，20，25，26，31，36，37，41，42，47，48</td>
            </tr>
            <tr class="bold">
              <th class="pc3">绿色</th>
              <td class="pc3">05，06，11，16，17，21，22，27，28，32，33，38，39，43，44，49</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          生肖中：指开奖7个号码中含有所属​​生肖的一个或多个号码，但派彩只派一次，即不论同生肖号码出现一个或多个号码都指派彩一次，生肖的号码随年份不同自动变化。
          <br />例如:2008年為鼠年
          <table class="TB_COLLAPSE m-5  tc"  width="100%">
            <thead>
              <th colspan="12" >生肖中</th>
            </thead>
            <tbody>
            <tr>
              <th>鼠</th>
              <td>01 13 25 37 49</td>
              <th>牛</th>
              <td>12 24 36 48</td>
              <th>虎</th>
              <td>11 23 35 47</td>
              <th>兔</th>
              <td>10 22 34 46</td>
            </tr>
            <tr>
              <th>龙</th>
              <td>09 21 33 45</td>
              <th>蛇</th>
              <td>08 20 32 44</td>
              <th>马</th>
              <td>07 19 31 43</td>
              <th>羊</th>
              <td>06 18 30 42</td>
            </tr>
            <tr>
              <th>猴</th>
              <td>05 17 29 41</td>
              <th>鸡</th>
              <td>04 16 28 40</td>
              <th>狗</th>
              <td>03 15 27 39</td>
              <th>猪</th>
              <td>02 14 26 38</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          生肖不中：指开奖7个号码中都不含有所属生肖的号码，即视为至中奖，但派彩只派一次，如下注牛，所属号码为09、21、33、45，开奖号码为1、14、25、33、13、35即视为中奖，如7个开奖号码中有09、21、33、45其中一个或几个，均视为不中奖。生肖的号码随年份不同自动变化。
          <br />例如:2008年為鼠年
          <table class="TB_COLLAPSE m-5  tc"  width="100%">
            <thead>
              <th colspan="12" >生肖不中</th>
            </thead>
            <tbody>
            <tr>
              <th>鼠</th>
              <td>01 13 25 37 49</td>
              <th>牛</th>
              <td>12 24 36 48</td>
              <th>虎</th>
              <td>11 23 35 47</td>
              <th>兔</th>
              <td>10 22 34 46</td>
            </tr>
            <tr>
              <th>龙</th>
              <td>09 21 33 45</td>
              <th>蛇</th>
              <td>08 20 32 44</td>
              <th>马</th>
              <td>07 19 31 43</td>
              <th>羊</th>
              <td>06 18 30 42</td>
            </tr>
            <tr>
              <th>猴</th>
              <td>05 17 29 41</td>
              <th>鸡</th>
              <td>04 16 28 40</td>
              <th>狗</th>
              <td>03 15 27 39</td>
              <th>猪</th>
              <td>02 14 26 38</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          尾数：指开奖7个号码中含有所属​​尾数的一个或多个号码，但派彩只派一次，即不论同尾数号码出现一个或多个号码都只派彩一次。
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >尾数</th>
            </thead>
            <tbody>
            <tr>
              <th>『1』尾</th>
              <td>1，11，21，31，41</td>
              <th>『2』尾</th>
              <td>2，12，22，32，42</td>
              <th>『3』尾</th>
              <td>3，13，23，33，43</td>
              <th>『4』尾</th>
              <td>4，14，24，34，44</td>
            </tr>
            <tr>
              <th>『5』尾</th>
              <td>5，15，25，35，45</td>
              <th>『6』尾</th>
              <td>6，16，26，36，46</td>
              <th>『7』尾</th>
              <td>7，17，27，37，47</td>
              <th>『8』尾</th>
              <td>8，18，28，39，48</td>
            </tr>
            <tr>
              <th>『9』尾</th>
              <td>9，19，29，39，49</td>
              <th>『0』尾</th>
              <td>10，20，30，40</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>例如：开奨结果正码是11、31、42、44、35、32特别号码是21则「1」尾「2」尾「4」尾「5」尾都为中奖，其它尾数都不中奖。 ',
        </li>
        <li>
          连码：
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >连码</th>
            </thead>
            <tbody>
            <tr>
              <th width="8%" class="pc1">三中二</th>
              <td>所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，视为中奖，叫三中二；若3个都是开奖号码中的正码，叫三中二之中三，其余情形视为不中奖，如03、04、05为一组合，开奖结果中有03、04两个正码，没有05，叫三中二，按三中二赔付；如开奖中有03、04、05三个正码，叫三中二之中三，按中三赔付；如出现1个或没有，视为不中奨。</td>
            </tr>
            <tr>
              <th class="pc1">三全中</th>
              <td>每三號碼為一組合，若三個號碼都是開奨號碼之正碼，視為中奨，其餘情形視為不中獎。如03、04、05三個都是開獎號碼之正瑪，視為中獎，如兩個正瑪加上一個特別號碼，視為不中奨。</td>
            </tr>
            <tr>
              <th class="pc1">二全中</th>
              <td>每二个号码为一组合，二个号码都是开奨号码之正码，视为中奨，其余情形视为不中奖（含一个正码加一个特别号码之情形）。</td>
            </tr>
            <tr>
              <th class="pc1">二中特</th>
              <td>每二个号码一组合，二个号码都是开奨号码之正码，叫二中特之中二；若其中一个是正码，一个是特别号码，叫二中特之中特；其余情形视为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">特串</th>
              <td>每二个号码为一组合》其中一个是正码， 一个是特别号码，视为中奨，其余情形视为不中奖（含二个号码都是正码之情形）。</td>
            </tr>
            <tr>
              <th class="pc1">拖头</th>
              <td>拖头是多组连码的简化叫法。如二中二之8拖18、28、13、25，即是4组：8-18、8-28、8-13、8-25 ;如三中二之8、18拖19、20、21 ，即是三组：8-18-19、8-18-20、8-18-21</td>
            </tr>
            <tr>
              <th class="pc1">复式</th>
              <td>复式是多个号码的不完全重复组合</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>六肖：挑选6生肖(排列如同生肖)为一个组合，并选择开奖号码的特码是否在此组合内(49号除外)，若选择是(中)且开奖号码的特码亦在此组合内，即视为中奖；若选择否(不中)且开奖号码的特码亦不在此组合内，即视为中奖；若当期特码开出49号，则所有组合皆视为和局。</li>
        <li>半波：以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖；若当期特码开出49号，则视为和局；其余情形视为不中奖。</li>
        <!-- <li>过关：任选2-8串为一投注组合，其赔率为所选串的当时赔率的总成绩。投注组合所选串必须全中才视为中奖。当投注组合中某一串号码为49号和时，该组合将该串赔率以1计算；当二串一组合中出现某一串为49和时，该组合将视为和局。单注最高彩金为25万（含彩金+佣金）。</li> -->
        <li>
          生肖连：（生肖所对应的号码和特码生肖项目的一样；一个生肖对应多个号码，不论同生肖的号码出现一个或多个，派彩只派一次。）
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >生肖连</th>
            </thead>
            <tbody>
            <tr>
              <th class="pc1" width="8%">二肖連（中）</th>
              <td>选择二个生肖为一投注组合进行下注。该注的二个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">二肖連（不中）</th>
              <td>选择二个生肖为一投注组合进行下注。该注的二个生肖必须没在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">三肖連（中）</th>
              <td>选择三个生肖为一投注组合进行下注。该注的三个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">三肖連（不中</th>
              <td>选择三个生肖为一投注组合进行下注。该注的三个生肖必须没在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">四肖連（中）</th>
              <td>选择四个生肖为一投注组合进行下注。该注的四个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">四肖連（不中）</th>
              <td>选择四个生肖为一投注组合进行下注。该注的四个生肖必须没在当期开出的7个开奖号码相对应的生肖中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">五肖連（中）</th>
              <td>选择五个生肖为一投注组合进行下注。该注的五个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            <tr>
              <th class="pc1">五肖連（不中）</th>
              <td>选择五个生肖为一投注组合进行下注。该注的五个生肖必须没在当期开出的7个开奖号码相对应的生肖中，视为中奖。</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          尾数连：（尾数所对应的号码和尾数项目的一样；一个尾数对应多个号码，不论同尾数的号码出现一个或多个，派彩只派一次。）
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >尾数连</th>
            </thead>
            <tbody>
            <tr>
              <th class="pc1" width="8%">二尾连（中）</th>
              <td>选择二个尾数为一投注组合进行下注。该注的二个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">二尾连（不中）</th>
              <td>选择二个尾数为一投注组合进行下注。该注的二个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">三尾连（中）</th>
              <td>选择三个尾数为一投注组合进行下注。该注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">三尾连（不中）</th>
              <td>选择三个尾数为一投注组合进行下注。该注的三个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">四尾连（中）</th>
              <td>选择四个尾数为一投注组合进行下注。该注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">四尾连（不中）</th>
              <td>选择四个尾数为一投注组合进行下注。该注的四个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">五尾连（中）</th>
              <td>选择五个尾数为一投注组合进行下注。该注的五个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            <tr>
              <th class="pc1">五尾连（不中）</th>
              <td>选择五个尾数为一投注组合进行下注。该注的五个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>特肖：当期开出的特码属下注的生肖，即为中奖，否则为不中奖，如今年2009是"牛"，投注特肖"牛"，若开出特码为1 ，13，25，37，49中的任一个，则中奨，否则不中奖。 49不算和。</li>
        <li>
          不中：
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >不中</th>
            </thead>
            <tbody>
            <tr>
              <th class="pc1" width="8%">五不中</th>
              <td>挑选5个号码为一投注组合进行下注。当期开出的7个开奖号码都没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，开奖号码为6，7，8，9，10，11，12，即为中奨，如果开奖号码为5，6，7，8，9， 10，11，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">六不中</th>
              <td>挑选6个号码为一投注组合进行下注。当期开出的7个开奖号码都没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，6，开奖号码为7，8，9，10，11，12，13，即为中奨，如果开奖号码为6，7，8，9， 10，11，12，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">七不中</th>
              <td>逃选7个号码为一投注组合进行下注。当期开出的7个间奖号码窀没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，6，7，开奨号码为8，9，10，11，12，13，14，即为中奨，如果开奖号码为7，8，9 ，10，11，12，13，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">八不中</th>
              <td>挑瘥8个号码为一投注组合进行下注。当期开出的7个开奖号码都没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，6，7，8，开奖号码为9，10，11，12，13，14，15，即为中奨，如果开奖号码为8，9， 10，11，12，13，14，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">九不中</th>
              <td>挑选9个号码为一投注组合进行下注。当期开出的7个开奖号码都没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，6，7，8，8，9，开奖号码为10，11，12，13，14，15， 16，即为中奨，如果开奖号码为9，10，11，12，13，14，15，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">十不中</th>
              <td>挑选10个号码为一投注组合进行下注。当期间出的7个开奖号码都没有在该下注组合中，即视为中奖。如下注组合为1，2，3，4，5，6，7，8，9，10，开奖号码为11，12，13，14，15， 16，17，即为中奨，如果开奖号码为10，11，12，13，14，15，16，那么为不中奖。</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          中一：(每個號碼都有自己的賠率，下注組合的總賠率，取該組合號碼的最低賠率為總賠率。)
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >中一</th>
            </thead>
            <tbody>
            <tr>
              <th class="pc1" width="8%">五中一</th>
              <td>挑选5个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，开奖号码为5，7，8，9，10，11，12，即为中奨，如果开奖号码为6，7，8，9，10， 11，12，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">六中一</th>
              <td>挑选6个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，6，开奖号码为6，8，9，10，11，12，13，即为中奨，如果开奖号码为5，6，8，9， 10，11，12，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">七中一</th>
              <td>逃选7个号码为一投注组合进行下注。当期开出的7个间奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，6，7，开奨号码为7，9，10，11，12，13，14，即为中奨，如果开奖号码为5，6，7 ，8，10，11，12，13，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">八中一</th>
              <td>挑瘥8个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，6，7，8，开奖号码为4，10，11，12，13，14，15，即为中奨，如果开奖号码为6，7， 8，11，12，13，14那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">九中一</th>
              <td>挑选9个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，6，7，8，8，9，开奖号码为9，11，12，13，14，15，16即为中奨，如果开奖号码为16 ，10，11，12，13，14，15那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">十中一</th>
              <td>挑选10个号码为一投注组合进行下注。当期间出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，6，7，8，9，10，开奖号码为10，12，13，14，15，16，17即为中奨，如果开奖号码为9 ，10，12，13，14，15，16那么为不中奖。</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>
          特平中：(每个号码都有自己的赔率，下注组合的总赔率，取该组合号码的最低赔率为总赔率。)
          <table class="TB_COLLAPSE m-5  tc" width="100%">
            <thead>
              <th colspan="12" >特平中</th>
            </thead>
            <tbody>
            <tr>
              <th class="pc1" width="8%">一粒任中</th>
              <td>挑选1个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，开奖号码为1，7，8，9，10，11，12，即为中奨，如果开奖号码为6，7，8，9，10，11，12，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">两粒任中</th>
              <td>挑选2个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，开奖号码为2，8，9，10，11，12，13，即为中奨，如果开奖号码为5，6，8，9，10，11，12，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">三粒任中</th>
              <td>逃选3个号码为一投注组合进行下注。当期开出的7个间奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，开奨号码为1，2，10，11，12，13，14，即为中奨，如果开奖号码为5，6，7，8，10，11，12 ，13，那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">四粒任中</th>
              <td>挑瘥4个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，开奖号码为4，10，11，12，13，14，15，即为中奨，如果开奖号码为6，7，8，11，12，13， 14那么为不中奖。</td>
            </tr>
            <tr>
              <th class="pc1">五粒任中</th>
              <td>挑选5个号码为一投注组合进行下注。当期开出的7个开奖号码只有一个号码在该下注组合中，即视为中奖；其余情况视为不中奖。如下注组合为1，2，3，4，5，开奖号码为4，5，12，13，14，15，16即为中奨，如果开奖号码为16，10，11，12，13，14 ，15那么为不中奖。</td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>一肖量：估猜开出的七个开奖号码中所属的不同生肖的总个数，例如︰投注【肖5】，若该期开出的七个号码中所属的不同生肖总个数为5，即视为中奖，若七个号码中所属的不同生肖的总个数大于5或小于5则为不中奖。</li>
      </ul>
      </i-col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
